// TSS vite/03 §"Query keys convention" + vite/04 §"Endpoint paths".
// Catálogo de razas del canal público (public-races.md, Q-124). Read-only,
// global (no scoped por cliente). Vive en common/ junto al RaceSelect que lo
// consume (selector de race_id al proponer donadoras).

export const raceKeys = {
    all:  ['races'],
    list: (filters) => ['races', filters],
};

export const racePaths = {
    list: () => 'public/races',
};
